import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[ellipsis]',
})
export class EllipsisDirective implements OnInit {
  private clamp = 1;

  /**
   * TODO Remove this when next release merged in master 07/2024
   */
  @Input()
  public set lineClamp(v: number) {
    this.clamp = v;
  }

  @Input('ellipsis')
  public set value(v: number) {
    this.clamp = v || 1;
  }

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.renderer.setStyle(this.el.nativeElement, 'display', '-webkit-box');
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    this.renderer.setStyle(this.el.nativeElement, 'text-overflow', 'ellipsis');
    this.renderer.setStyle(this.el.nativeElement, '-webkit-box-orient', 'vertical');
    this.renderer.setStyle(this.el.nativeElement, 'overflow-wrap', 'anywhere');
    this.renderer.setStyle(this.el.nativeElement, '-webkit-line-clamp', this.clamp);
  }
}
